export {ActivitiesModule} from './core/activities.module';
export {LessonsModule} from './core/lessons/lessons.module';
export {LessonsService} from './core/lessons/lessons.service';
export {ThemesModule} from './core/themes/themes.module';
